import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHome: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconHome"><Path fillRule="evenodd" clipRule="evenodd" d="M11.5251 1.41953C11.8013 1.19349 12.1987 1.19349 12.4749 1.41953L20.7249 8.16953C20.899 8.31198 21 8.52505 21 8.75V20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.55109 21 3.36032 20.921 3.21967 20.7803C3.07902 20.6397 3 20.4489 3 20.25V8.75C3 8.52505 3.10097 8.31198 3.27507 8.16953L11.5251 1.41953Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHome;
